import i18next from "i18next";
import { globalSystemConstants, refundPolicyConstants } from "../../constants";
import { ToastifyService } from "../../services";
import { refundPolicyService } from "../../services/refundPolicy.service";
import { custom, success } from "./utilities";

const getRefundPolicy = () => {
  return (dispatch) => {
    dispatch(
      custom(
        refundPolicyConstants.GET_REFUND_POLICY_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    refundPolicyService
      .getRefundPolicyData()
      .then((response) => {
        dispatch(
          success(response, refundPolicyConstants.GET_REFUND_POLICY_DATA)
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            refundPolicyConstants.GET_REFUND_POLICY_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
const updateRefundPolicy = (fundPolicyData) => {
  return (dispatch) => {
    dispatch(
      custom(
        refundPolicyConstants.UDPATE_REFUND_POLICY_TYPE,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    refundPolicyService
      .updateFundPolicyTypes(fundPolicyData)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        RefundPolicyActions.getRefundPolicy();
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            refundPolicyConstants.UDPATE_REFUND_POLICY_TYPE,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const RefundPolicyActions = {
  getRefundPolicy,
  updateRefundPolicy,
};
